<template>
  <div v-if="overview" class="card-page d-flex flex-column">
    <div class="card flex-grow-0">
      <div class="card-body">
        <div class="row">
          <div class="col-1">
            &nbsp;
          </div>
          <div class="col ml-3 text-center">
            <p class="h2"><span class="text-secondary h3">Flerårskompass för</span> {{overview.NAME}}</p>
          </div>
          <div class="col-1">
            &nbsp;
          </div>
        </div>
      </div>
    </div>

    <div v-if="ranking" class="card mt-2 flex-grow-1">
      <div class="card-body">
        <div class="row py-2">
          <div class="col-7" style="border-right: 1px solid lightgray;">
            <Compass :rankings="ranking" :years="3" :showBransch="false" :showLabels="false" />
          </div>
          <div class="col-5">
            <div class="ml-1" style="font-size: 1.2rem;">
                <div v-for="(r,index) in ranking.sheets.slice(0,3)" :key="index" class="p-2 my-3" :style="getStyle(index)">
                    <div class="row">
                        <div class="col-6">
                            <PLabel v-if="isSie && index===0" class="mt-2" type="smallNarrow">SIE-IMPORT</PLabel>
                            <PLabel v-else class="mt-2" type="smallNarrow">BOKSLUT</PLabel>
                            <PValue type="smallNarrow">{{r.DATE_TO.substring(0, 7)}}</PValue>
                            <PLabel class="mt-2" type="smallNarrow">NETTOOMSÄTTNING</PLabel>
                            <PValue type="smallNarrow">{{r.PL_NET_SALES | D0 | tkr}}</PValue>
                            <PLabel class="mt-2" type="smallNarrow">BALANSOMSLUTNING</PLabel>
                            <PValue type="smallNarrow">{{r.BS_TOT_ASSETS | D0 | tkr}}</PValue>
                        </div>
                        <div class="col-6">
                            <PLabel class="mt-2" type="smallNarrow">BEDÖMNING</PLabel>
                            <PValue type="smallNarrow">{{r.ranks.score}} / 400</PValue>
                            <PLabel class="mt-2" type="smallNarrow">RÖRELSERESULTAT</PLabel>
                            <PValue type="smallNarrow">{{r.PL_OPERATING_RESULT | D0 | tkr}}</PValue>
                            <PLabel class="mt-2" type="smallNarrow">EGET KAPITAL</PLabel>
                            <PValue type="smallNarrow">{{r.BS_TOT_EQUITY | D0 | tkr}}</PValue>
                        </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { Component, Vue } from 'vue-property-decorator';
    import user from '@/store/modules/user';
    import CompanyMixin from '@/mixins/CompanyMixin';
    import { colors } from '../config';

    @Component({mixins: [CompanyMixin]})
    export default class CardCompassYears extends Vue {
      get isSie() {
        return user.activeSie !== null;
      }

      getStyle(index) {
          switch (index) {
              case 0:
                  return `border: 2px solid ${colors.Primary}; border-left: 12px solid ${colors.Primary};`;
              case 1:
                  return `border: 2px solid  ${colors.Secondary}; border-left: 12px solid  ${colors.Secondary};`;
              default:
                  return `border: 2px solid  ${colors.Tertiary}; border-left: 12px solid  ${colors.Tertiary};`;
          }
      }
    }
</script>

<style scoped>
  pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: inherit;
  }
</style>
